import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AbstractControl, FormBuilder, FormGroup, Validators, ValidationErrors } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HomeService } from "../home/home.services";

@Component({
  selector: "app-side-bar",
  templateUrl: "./side-bar.component.html",
  styleUrls: ["./side-bar.component.scss"],
})
export class SideBarComponent implements OnInit {
  sidebarItems: any[];
  isSideBarOpen = false;
  activeIndex: number = null;
  userName = "";
  name: any;
  isAdmin = false;
  profile;
  sidebar_access = {};
  password: string = '';
  passwordForm!: FormGroup;
  showConfirmationDialog: boolean = false;
  currentPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  hideCurrentPassword: boolean = true;
  hideNewPassword: boolean = true;
  hideConfirmPassword: boolean = true;
  email: any;

  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private toastr: ToastrService,
    private HomeService: HomeService
  ) {
    this.sidebarItems = [
      { title: "Data Directory", icons: "fa fa-book", path: "/datadirectory" },
      { title: "Search Molecule", icons: "fa fa-search", path: "/home" },
      // { title: "Costing", icons: "fa fa-calculator", path: "/costing" },
      { title: "Costing", icons: "fa fa-calculator", path: "/new-costing" },
      { title: "Business Case", icons: "fa fa-briefcase", path: "/settings" },
      { title: "Est API", icons: "fa fa-sticky-note-o", path: "/est_api" },
      { title: "Est RLD", icons: "fa fa-industry", path: "/est_rld" },
      {
        title: "Commercial Intelligence",
        icons: "fa fa-table",
        path: "/commercial_intelligence",
      },
      // {
      //   title: "Sales Volume",
      //   icon: "fa fa-folder-open",
      //   path: "/sales_volume",
      // },
      // { title: "Manual Entry", icons: "fa fa-edit", path: "/userform" },
      { title: "Upload Files", icons: "fa fa-upload", path: "/uploadfiles" },
      // { title: "Reports", icons: "fa fa-file-excel-o", path: "/reports" },
      // { title: "File Upload", icons: "fa fa-sign-out", path: "/fileupload" },
      {
        title: "File Sales and Volume",
        icons: "fa fa-bar-chart",
        path: "/filessalesandvolume",
      },
      // {
      //   title: "User Register",
      //   icons: "fa fa-bar-chart",
      //   path: "/userregister",
      // },
      // {
      //   title: "LifeCycle Intellegence",
      //   icons: "fa fa-life-ring",
      //   path: "/lifecycleintellegence",
      // },
      {
        title: "Scraping Update",
        icons: "fa fa-bar-chart",
        path: "/scrapingupdate",
      },
      {
        title: "LMS",
        icons: "fa fa-line-chart",
        path: "/logmanagement",
      },
      {
        title: "PDUFA",
        icons: "fa fa-line-chart",
        path: "/pdufa",
      },
      {
        title: "Error Dashboard",
        icons: "fas fa-exclamation-triangle",
        path: "/errordashboard",
      },
      {
        title: "Upload To Live",
        icons: "fa fa-globe",
        path: "/uploadtolive",
      },
      {
        title: "User Registration",
        icons: "fa fa-user",
        path: "/user-registration",
      },
      {
        title: "Company Master",
        icons: "fa fa-building",
        path: "/company-master",
      },
      {
        title: "Request Training",
        icons: "fa fa-comment",
        path: "/request-training",
      },
      {
        title: "Product Dashboard",
        icons: "fa fa-list",
        path: "/product-dashboard",
      },
      {
        title: "Excel Manager",
        icons: "fa fa-file",
        path: "/excel-manager"
      },
      {
        title: "Peak Sale",
        icons: "fa fa-chart-line",
        path: "/peak-sale",
      },
      {
        title: "Email Litigation",
        icons: "fa fa-envelope",
        path: "/litigation-dashboard",
      },
      {
        title: "Litigation Complaints",
        icons: "fa fa-file-pdf",
        path: "/litigation-complaints",
      },
      {
        title: "Rights Wise Access",
        icons: "fa fa-user-plus",
        path: "/register-user",
      },
      // {
      //   title: "Subscriber Email",
      //   icons: "fa fa-paper-plane",
      //   path: "/subscriber-email",
      // },
      {
        title: "New Subscriber Email",
        icons: "fa fa-paper-plane",
        path: "/new-subscriber-email",
      },
      {
        title: "Subscriber Mail Users",
        icons: "fa fa-bars",
        path: "/subscriber-mail-users",
      },
      {
        title: "Field Reviews Dashboard",
        icons: "fa fa-check-circle",
        path: "/field-review-dashboard",
      },
      { title: "Business Case", icons: "fa fa-briefcase", path: "/user-own-setting" },
      { title: "Sale Volume Compare", icons: "fa fa-briefcase", path: "/sale-volume-compare" },
      { title: "Get Most Searched", icons: "fa fa-briefcase", path: "/get-most-searched" },
      {
        title: "Product Status Dashboard",
        icons: "fa fa-product-hunt",
        path: "/product-status-dashboard",
      },
      {
        title: "Excel Dump Dashboard",
        icons: "fa fa-file-excel",
        path: "/excel-dump",
      },
      {
        title: "Important Updates",
        icons: "fa fa-bell",
        path: "/important-updates",
      },
      {
        title: "Section Wise Email",
        icons: "fa fa-bars",
        path: "/section-wise-email",
      },
      {
        title: "LMS DS Manual Entry",
        icons: "fa fa-edit",
        path: "/lms-ds-manual-entry",
      },
      {
        title: "Push to Live",
        icons: "fa fa-globe",
        path: "/push-to-live",
      },
      {
        title: "PTE Events",
        icons: "fa fa-calendar",
        path: "/pte-events",
      },
      {
        title: "Upload Shortage File",
        icons: "fa fa-file-excel-o",
        path: "/upload-shortage-file",
      },
      {
        title: "Shortage Panel",
        icons: "fa fa-exclamation-circle",
        path: "/shortage-panel",
        visibility: true,
      },
      {
        title: "Log Out",
        icons: "fa fa-sign-out",
        path: "/login"
      }
    ];
  }

  ngOnInit(): void {
    //add this for AD
    this.email = localStorage.getItem("email");
    this.sidebarItems.map((eachItem, ind) => {
      if (eachItem.path === this.router.url) {
        this.activeIndex = ind;
      }
    });

    this.passwordForm = this.formBuilder.group({
      currentPassword: ['', [Validators.required, Validators.minLength(8)]],
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]]
    }, {
      validators: this.passwordValidator.bind(this)
    });

    /* this code has been commented by harsh.k on 25-nov-2022 start */
    // setTimeout(() => {
    //   let userDetails = localStorage.getItem("user_data");
    //   userDetails = JSON.parse(userDetails)
    //   this.userName = localStorage.getItem('Name');

    //   this.sidebarItems = [
    //     { title: 'Data Directory', icons: 'fa fa-book', path: '/datadirectory'},
    //     { title: 'Search Molecule', icons: 'fa fa-search', path: '/home' },
    //     { title: 'Costing', icons: 'fa fa-calculator', path: '/costing' },
    //     { title: 'Business Case', icons: 'fa fa-briefcase', path: '/settings'},
    //     { title: 'Manual Entry', icons: 'fa fa-edit', path: '/userform'},
    //     { title: 'Upload Files', icons: 'fa fa-upload', path: '/uploadfiles'},
    //     { title: 'Reports', icons: 'fa fa-file-excel-o', path: '/reports'},
    //     { title: 'Log Out', icons: 'fa fa-sign-out', path: '/login' },
    //   ];
    // }, 1000);
    /* this code has been commented by harsh.k on 25-nov-2022 end */

    /* this code has been added by harsh.k on 25-nov-2022 start */
    let userDetails = localStorage.getItem("user_data");
    userDetails = JSON.parse(userDetails);
    this.userName = localStorage.getItem("Name");

    this.sidebarItems = [
      {
        title: "Data Directoryssss",
        icons: "fa fa-book",
        path: "/datadirectory",
        visibility: true,
      },
      {
        title: "Search Molecule",
        icons: "fa fa-search",
        path: "/home",
        visibility: true,
      },
      // {
      //   title: "Costing",
      //   icons: "fa fa-calculator",
      //   path: "/costing",
      //   visibility: false,
      // },
      {
        title: "Costing",
        icons: "fa fa-calculator",
        path: "/new-costing",
        visibility: false,
      },
      {
        title: "Business Case",
        icons: "fa fa-briefcase",
        path: "/settings",
        visibility: false,
      },
      {
        title: "Est API",
        icons: "fa fa-sticky-note-o",
        path: "/est_api",
        visibility: false,
      },
      {
        title: "Est RLD",
        icons: "fa fa-industry",
        path: "/est_rld",
        visibility: false,
      },
      {
        title: "Commercial Intelligence",
        icons: "fa fa-table",
        path: "/commercial_intelligence",
        visibility: false,
      },
      // {
      //   title: "Sales Volume",
      //   icons: "fa fa-folder-open",
      //   path: "/sales_volume",
      //   visibility: true,
      // },
      // {
      //   title: "Manual Entry",
      //   icons: "fa fa-edit",
      //   path: "/userform",
      //   visibility: false,
      // },
      {
        title: "Upload Files",
        icons: "fa fa-upload",
        path: "/uploadfiles",
        visibility: false,
      },
      // {
      //   title: "Reports",
      //   icons: "fa fa-file-excel-o",
      //   path: "/reports",
      //   visibility: false,
      // },
      // {
      //   title: "File Upload",
      //   icons: "fa fa-cloud-upload",
      //   path: "/fileupload",
      //   visibility: true,
      // },
      {
        title: "Files Sales and Volume",
        icons: "fa fa-bar-chart",
        path: "/filessalesandvolume",
        visibility: true,
      },
      // {
      //   title: "User register",
      //   icons: "fa fa-user-plus",
      //   path: "/userregister",
      //   visibility: true,
      // },
      // {
      //   title: "LifeCycle Intellegence",
      //   icons: "fa fa-life-ring",
      //   path: "/lifecycleintellegence",
      //   visibility: true,
      // },
      {
        title: "Scraping Update",
        icons: "fa fa-bar-chart",
        path: "/scrapingupdate",
        visibility: true,
      },
      {
        title: "LMS",
        icons: "fa fa-line-chart",
        path: "/logmanagement",
        visibility: false,
      },
      {
        title: "PDUFA",
        icons: "fa fa-line-chart",
        path: "/pdufa",
        visibility: true,
      },
      {
        title: "Error Dashboard",
        icons: "fas fa-exclamation-triangle",
        path: "/errordashboard",
        visibility: true,
      },
      {
        title: "Upload To Live",
        icons: "fa fa-globe",
        path: "/uploadtolive",
        visibility: true,
      },
      {
        title: "User Registration",
        icons: "fa fa-user",
        path: "/user-registration",
        visibility: true,
      },
      {
        title: "Company Master",
        icons: "fa fa-building",
        path: "/company-master",
        visibility: true,
      },
      {
        title: "Request Training",
        icons: "fa fa-comment",
        path: "/request-training",
        visibility: true,
      },
      {
        title: "Product Dashboard",
        icons: "fa fa-list",
        path: "/product-dashboard",
        visibility: true,
      },
      {
        title: "Excel Manager",
        icons: "fa fa-file",
        path: "/excel-manager",
        visibility: true,
      },
      {
        title: "Peak Sale",
        icons: "fa fa-chart-line",
        path: "/peak-sale",
        visibility: true,
      },
      {
        title: "Email Litigation",
        icons: "fa fa-envelope",
        path: "/litigation-dashboard",
        visibility: true,
      },
      {
        title: "Litigation Complaints",
        icons: "fa fa-file-pdf",
        path: "/litigation-complaints",
        visibility: true,
      },
      {
        title: "Rights Wise Access",
        icons: "fa fa-user-plus",
        path: "/register-user",
        visibility: true,
      },
      // {
      //   title: "Subscriber Email",
      //   icons: "fa fa-paper-plane",
      //   path: "/subscriber-email",
      //   visibility: true,
      // },
      {
        title: "New Subscriber Email",
        icons: "fa fa-paper-plane",
        path: "/new-subscriber-email",
        visibility: true,
      },
      {
        title: "Subscriber Mail Users",
        icons: "fa fa-bars",
        path: "/subscriber-mail-users",
        visibility: true,
      },
      {
        title: "Field Reviews Dashboard",
        icons: "fa fa-check-circle",
        path: "/field-review-dashboard",
        visibility: true,
      },
      {
        title: "Business Case",
        icons: "fa fa-briefcase",
        path: "/user-own-setting",
        visibility: false,
      },
      { title: "Sale Volume Compare", icons: "fa fa-briefcase", path: "/sale-volume-compare", visibility: true },
      { title: "Get Most Searched", icons: "fa fa-briefcase", path: "/get-most-searched", visibility: true },
      {
        title: "Product Status Dashboard",
        icons: "fa fa-product-hunt",
        path: "/product-status-dashboard",
        visibility: true,
      },
      {
        title: "Excel Dump Dashboard",
        icons: "fa fa-file-excel",
        path: "/excel-dump",
        visibility: true,
      },
      {
        title: "Important Updates",
        icons: "fa fa-bell",
        path: "/important-updates",
        visibility: true,
      },
      {
        title: "Section Wise Email",
        icons: "fa fa-bars",
        path: "/section-wise-email",
        visibility: true,
      },
      {
        title: "LMS DS Manual Entry",
        icons: "fa fa-edit",
        path: "/lms-ds-manual-entry",
        visibility: true,
      },
      {
        title: "Push to Live",
        icons: "fa fa-calendar",
        path: "/push-to-live",
        visibility: true,
      },
      {
        title: "PTE Events",
        icons: "fa fa-calendar",
        path: "/pte-events",
        visibility: true,
      },
      {
        title: "Upload Shortage File",
        icons: "fa fa-file-excel-o",
        path: "/upload-shortage-file",
        visibility: true,
      },
      {
        title: "Shortage Panel",
        icons: "fa fa-exclamation-circle",
        path: "/shortage-panel",
        visibility: true,
      },
      {
        title: "Log Out",
        icons: "fa fa-sign-out",
        path: "/login",
        visibility: true,
      }
    ];
    this.sidebar_access =
      JSON.parse(localStorage.getItem("sidebar_access")) || {};
    let sidebar_keys = Object.keys(this.sidebar_access);
    console.log(sidebar_keys);
    for (let i = 0; i < this.sidebarItems.length; i++) {
      for (let j = 0; j < sidebar_keys.length; j++) {
        if (this.sidebarItems[i].title === sidebar_keys[j]) {
          this.sidebarItems[i].visibility =
            this.sidebar_access[sidebar_keys[j]];
          break;
        }
      }
    }
    /* this code has been added  by harsh.k on 25-nov-2022 end */
  }

  get f(): { [key: string]: AbstractControl } { return this.passwordForm.controls; }

  togglePasswordVisibility(field: string): void {
    switch (field) {
      case 'current':
        this.hideCurrentPassword = !this.hideCurrentPassword;
        break;
      case 'new':
        this.hideNewPassword = !this.hideNewPassword;
        break;
      case 'confirm':
        this.hideConfirmPassword = !this.hideConfirmPassword;
        break;
    }
  }

  selecteByRoute(selectedItem, ind): any {
    this.sidebarItems.map((eachItem) => {
      if (eachItem.title === selectedItem.title) {
        this.activeIndex = ind;
        this.router.navigate([`${selectedItem.path}`]);
      }
    });
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  passwordValidator(formGroup: FormGroup): ValidationErrors | null {
    const newPassword = formGroup.get('newPassword');
    const confirmPassword = formGroup.get('confirmPassword');

    if (!newPassword || !confirmPassword) {
      return null;
    }

    const newPasswordValue = newPassword.value;
    const confirmPasswordValue = confirmPassword.value;

    let errors: Record<string, boolean> = {};

    // Password complexity checks for newPassword
    const hasUpperCase = /[A-Z]/.test(newPasswordValue);
    const hasLowerCase = /[a-z]/.test(newPasswordValue);
    const hasNumber = /\d/.test(newPasswordValue);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(newPasswordValue);
    const isMinLength = newPasswordValue.length >= 8;

    if (!hasUpperCase) {
      errors['uppercaseRequired'] = true;
    }
    if (!hasLowerCase) {
      errors['lowercaseRequired'] = true;
    }
    if (!hasNumber) {
      errors['numberRequired'] = true;
    }
    if (!hasSpecialChar) {
      errors['specialCharRequired'] = true;
    }
    if (!isMinLength) {
      errors['minLengthRequired'] = true;
    }

    if (Object.keys(errors).length > 0) {
      newPassword.setErrors(errors);
    } else {
      newPassword.setErrors(null);
    }

    if (newPasswordValue !== confirmPasswordValue) {
      confirmPassword.setErrors({ passwordMismatch: true });
    } else {
      confirmPassword.setErrors(null);
    }

    if (Object.keys(errors).length > 0 || confirmPassword.errors) {
      return errors;
    }

    return null;
  }

  submitChangePassword() {
    if (this.passwordForm.valid) {
      // console.log('Form submitted successfully');
    } else {
      // console.log('Form submission failed. Please fill in all required fields or ensure passwords match.');
    }
  }


  onConfirm() {
    console.log("nvjlnvk")
    const data = {
      ...this.passwordForm.value,
      email: this.email
    };
    this.HomeService.ResetAdminPassword(data).subscribe((response) => {
      // console.log("response", response);
      this.toastr.success(response['message']);
      this.showConfirmationDialog = false;
      this.passwordForm.reset();
      this.router.navigate(['/login']);
      localStorage.clear();
    },
      (error) => {
        this.toastr.error(error.error.error);
      });
  }

  onCancel() {
    this.showConfirmationDialog = false;
    this.passwordForm.reset();
  }

  showConfirmDialog() {
    this.showConfirmationDialog = true;
    this.isSideBarOpen = false;
  }
}